// Figma exports its loading glyphs as static SVGs (button-spinner-icon / page-spinner-icon);
// the spin motion itself isn't part of the asset, so we apply it with a CSS rotation.
import React from 'react';
import PropTypes from 'prop-types';
import {Box} from '@mui/material';

const SpinnerIcon = ({src, size = 16}) => (
    <Box
        component="img"
        src={src}
        alt=""
        sx={{
            width: size,
            height: size,
            display: 'block',
            animation: 'auth-spin 0.8s linear infinite',
            '@keyframes auth-spin': {
                from: {transform: 'rotate(0deg)'},
                to: {transform: 'rotate(360deg)'}
            }
        }}
    />
);

SpinnerIcon.propTypes = {
    src: PropTypes.string.isRequired,
    size: PropTypes.number
};

export default SpinnerIcon;
